import * as ActionTypes from '../actions/allActions'
const Raven = require('raven-js')

export default store => next => action => {
	next(action)
	window.dataLayerGTM.push({ event: "Action Fired", actionType: action.type })

	switch(action.type){
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
			Raven.setExtraContext({
				userId: action.data.data.id,
			})
			break
		case ActionTypes.BOOKINGFLOW_METACHANGE:
			if(action.changes.currentStep){
				window.dataLayerGTM.push({
					event: "Booking flow step reached",
					bookingFlowToStep: action.changes.currentStep,
					bookingFlowFromStep: store.getState().metadataReducer.bookingFlow.currentStep,
				})
			}
			break
		default:
			// nothing
	}
}



// WEBPACK FOOTER //
// ./src/middleware/googleTagManagerMiddleware.js